import * as React from 'react'
import { useApiGetForecastByCountryCode } from '../../../core/api/upward-forecast/useApiGetForecastByCountryCode'
import { useFilters } from '../../common/filters3/filters/hooks/useFilters'
import { GenericFilters } from '../../common/filters3/filters/definitions'
import { useTranslation } from 'react-i18next'

const UpwardForecastMessage = () => {
  const { t } = useTranslation()
  const {
    appliedFilters: { country }
  } = useFilters<GenericFilters>()
  const { data: dataForecastByCountryCode } = useApiGetForecastByCountryCode({ countryCode: country })
  const isActivated = dataForecastByCountryCode ? dataForecastByCountryCode.activated : false
  return dataForecastByCountryCode ? (
    <p data-testid={`forecast-message-${isActivated ? 'activated' : 'deactivated'}`}>
      {isActivated ? (
        <span className="upward-forecast__important-message">{t('upward-forecast.activated.message')} </span>
      ) : null}
      {t(isActivated ? 'upward-forecast.activated.exception-message' : 'upward-forecast.deactivated.message')}
    </p>
  ) : null
}

export default React.memo(UpwardForecastMessage)
